import { connect } from "react-redux"

import { filterProductOptionsV2 } from "helpers/product/product-filtering"

export default function withTotalItemPrice(WrappedComponent) {
  const InternalWithTotalItemPrice = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = (state) => {
    const choices = state.choices || {}
    const productAddons = state.wizard.addons
      ? filterProductOptionsV2(
          state.wizard.addons.filter((addon) => addon.in_stock),
          choices,
          true
        )
      : []
    const selectedProductAddons = state.choices.addon
      ? state.choices.addon.value
      : []

    const productPrice = state.wizardUI.currentPricing.price_to_display
    const boxPrice =
      state.choices.box && state.choices.box.price ? state.choices.box.price : 0
    const productAddonPrice = productAddons
      .filter((addon) => selectedProductAddons.includes(addon.set_key))
      .reduce((sum, addon) => (sum += addon.surcharge), 0)
    const warrantyPrice =
      state.choices.warranty && state.choices.warranty.value
        ? state.choices.warranty.value.price || 0
        : 0
    const totalItemPrice = productPrice
      ? productPrice + boxPrice + productAddonPrice + warrantyPrice
      : null

    return {
      totalItemPrice,
    }
  }

  const WithTotalItemPrice = connect(mapStateToProps)(
    InternalWithTotalItemPrice
  )

  return WithTotalItemPrice
}
